import { formatYYYYMMDD } from '@webapp/core/utils/dates/formatYYYYMMDD'
import { type LegacyOrderDraftConstructorData } from '../../../entities/LegacyOrderDraft'
import { type IOrderDraftRepository } from '../../interfaces/IOrderDraftRepository'

export class GetAutomationOrderDraftUseCase {
  constructor(
    private readonly deps: {
      orderDraftRepository: IOrderDraftRepository
    }
  ) {}

  execute = async (): Promise<LegacyOrderDraftConstructorData> => {
    const orderDraft =
      await this.deps.orderDraftRepository.getAutomationOrderDraft()

    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)

    const sevenDaysFromNow = new Date()
    sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 7)
    sevenDaysFromNow.setHours(0, 0, 0, 0)

    let correctedDateRequired: Nullable<string> = orderDraft.dateRequired

    if (correctedDateRequired === null) {
      // If no required date has previously been set, default to 7 days from now
      correctedDateRequired = formatYYYYMMDD(sevenDaysFromNow)
    } else if (
      // Otherwise, ensure the date is no earlier than today
      new Date(correctedDateRequired).getTime() < startOfToday.getTime()
    ) {
      correctedDateRequired = formatYYYYMMDD(startOfToday)
    }

    return {
      ...orderDraft,
      dateRequired: correctedDateRequired,
    }
  }
}
